import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import { Close, Error as ErrorIcon } from '@material-ui/icons';
import {
  IconButton,
  Snackbar,
  SnackbarContent,
} from '@material-ui/core';

import styles from './styles';

const ErrorBar = ({ classes, open, onClose, message }) => (
  <Snackbar
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    open={open}
    autoHideDuration={6000}
    onClose={onClose}
  >
    <SnackbarContent
      className={classes.error}
      aria-describedby="error-bar"
      message={
        <span id="error_bar" className={classes.message}>
          <ErrorIcon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <Close className={classes.icon} />
        </IconButton>,
      ]}
    />
  </Snackbar>
);

ErrorBar.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string,
};

ErrorBar.defaultProps = {
  message: '',
};

export default withStyles(styles)(ErrorBar);



// WEBPACK FOOTER //
// ./src/app/components/ErrorBar/index.js